import React, { useEffect } from "react";
import Modal from "react-modal";

import * as S from "./styles";

const customStyles = {
	overlay: {
		zIndex: '1090',
		backgroundColor: 'rgba(0, 0, 0, 0.5)',
		backdropFilter: 'blur(4px)'
	},
	content: {
		position: 'static',
		height: '100%',
		borderWidth: '0',
		borderRadius: 'none',
		backgroundColor: 'transparent'
	},
};

const _Modal = ({ children, ...attr }) => {
	const { isOpen, onClose } = attr;

	useEffect(() => {
		if (isOpen) {
			document.documentElement.style.overflow = 'hidden';
		} else {
			document.documentElement.removeAttribute('style');
		}
	}, [isOpen]);

	return (
		<Modal
			isOpen={isOpen}
			style={customStyles}
			ariaHideApp={false}
		>
			<S.Modal>
				<div className="header">
					<div className="lines"></div>
					<button className="close" onClick={onClose}></button>
				</div>
				<div className="body">
					{children}
				</div>
			</S.Modal>
		</Modal>
	)
}

export default _Modal;